module.exports = __webpack_public_path__ + "media/images/account/edit-icon-ffed8c5cec78c92c23f01cb9e462928f.svg";